import { useSelector } from "react-redux";

import {
  useAgentFaqs,
  useVestedAgentsFaqs,
} from "js/placeholderData/agents/authed-agent-faqs";
import { useUnauthAgentFaqs } from "js/placeholderData/agents/unauth-agent-faqs";

export default function useAgentTopThreeFAQs() {
  const { user } = useSelector((s) => s.user);
  const { agent } = useSelector((s) => s.getAgent);
  const unauthAgentFaqs = useUnauthAgentFaqs();
  const agentFaqs = useAgentFaqs();
  const vestedAgentsFaqs = useVestedAgentsFaqs();

  if (!user?.userId) return unauthAgentFaqs.slice(0, 3);

  if (agent?.status?.toUpperCase() !== "A") return vestedAgentsFaqs.slice(0, 3);

  return agentFaqs.slice(0, 3);
}
